/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Row,
  Col
} from "reactstrap";
import classnames from "classnames";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";

const TabGroup2 = props => {
  const [activeTab, setActiveTab] = useState("1");
  const [tap1, setTap1] = useState("");
  const [tap2, setTap2] = useState("");
  const [tap3, setTap3] = useState("");
  const [tap4, setTap4] = useState("");

  useEffect(() => {

    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       console.log(result);
    //       setTap1(result.data[0].label);
    //       setTap2(result.data[1].label);
    //       setTap3(result.data[2].label);
    //       setTap4(result.data[3].label);
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );

      axios("/api/v1/group1")
      .then(
        result => {
          var res = result.data;
          setTap1(res.data[0].label);
          setTap2(res.data[1].label);
          setTap3(res.data[2].label);
          setTap4(res.data[3].label);
        }, error => {console.log(error);}
      );  

    if (props.setTap !== null) {
      setActiveTab(props.setTap);
    }
  }, []);

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
    handleChange(tab);
  };
  function handleChange(e) {
    props.tap(e);
  }
  return (
    <div>
      <Nav
        tabs
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          flexWrap: "wrap",
          padding: "10px"
        }}
      >
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => {
              toggle("1");
            }}
          >
            {tap1}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => {
              toggle("2");
            }}
          >
            {tap2}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "3" })}
            onClick={() => {
              toggle("3");
            }}
          >
            {tap3}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "4" })}
            onClick={() => {
              toggle("4");
            }}
          >
            {tap4}
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Row>
            <Col sm="12"></Col>
          </Row>
        </TabPane>
        <TabPane tabId="2">
          <Row>
            <Col sm="6"></Col>
            <Col sm="6"></Col>
          </Row>
        </TabPane>
        <TabPane tabId="3">
          <Row>
            <Col sm="12"></Col>
          </Row>
        </TabPane>
        <TabPane tabId="4">
          <Row>
            <Col sm="12"></Col>
          </Row>
        </TabPane>
      </TabContent>
    </div>
  );
};

export default TabGroup2;
